module.exports = __webpack_public_path__ + "img/暂无报名@2x.ccff04cc.png";